import React, { Fragment } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { useLanguage } from '../../../../context/LanguageProvider';
import { NepNowDateFormat } from '../../../../constants/DateFormat';
import { NumberToNepaliNum } from '../../../../helpers/DateFormat';
import AppURL from '../../../../constants/AppURL';

const PrintMahasulRptListView = ({ onMahasulReport }: any) => {
  const { SOFTWARE_ORG, ACCOUNT_RPT_DATE } = useSelector((state: RootState) => state.software);
  const org_details = SOFTWARE_ORG?.org;
  const date_report = ACCOUNT_RPT_DATE.acc_rpt;
  const { language } = useLanguage();
  const DateNow = NepNowDateFormat();
  return (
    <Fragment>
      <style>
        {`@media print {
                    @page {
                        size: A4 potrait;
                        margin: 0.2in;
                        border: 1px solid #cbd5e1; 
                        page-break-before: always;
                    }
                }
            `}
      </style>
      <div className="relative p-2">
        <table className="w-full text-sm text-left rtl:text-right text-black">
          <tbody>
            <tr>
              <td className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`} >
                {language === "Eng" ? "S. Code: " : "एस. कोड:"}:  {language === "Eng" ? org_details?.org_reg : NumberToNepaliNum(org_details?.org_reg || "")}
              </td>
              <td className="w-[25%]">
              </td>
              <td className="w-[25%]">
              </td>
              <td align='right' className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                {language === "Eng" ? "Phone: " : "फोन नम्बर:"}  {language === "Eng" ? org_details?.org_phone : NumberToNepaliNum(org_details?.org_phone || 0)}
              </td>
            </tr>
            <tr >
              <td rowSpan={4} className="w-[25%] font-medium text-black whitespace-nowrap dark:text-white">
                <img width={60} height={60} src={AppURL.BaseURL + org_details?.logo} alt="" />
              </td>
              <td align='center' colSpan={2} className={`w-[25%] text-black font-bold text-[18px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                {language === "Eng" ? org_details?.org_name : org_details?.org_name_nep}
              </td>
              <td className="w-[25%]">
              </td>
            </tr>
            <tr >
              <td align='center' colSpan={2} className={`w-[25%] text-black font-normal text-[12px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                {language === "Eng" ? org_details?.org_add : org_details?.org_add_nep}
              </td>
              <td align='right' className={`w-[25%] text-[11px] text-black font-normal ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                {language === "Eng" ? "Date: " : "मिति: "} {language === "Eng" ? DateNow : NumberToNepaliNum(DateNow)}
              </td>
            </tr>
            <tr >
              <td align='center' colSpan={2} className={`w-[25%] underline underline-offset-2 text-black text-[15px] ${language === "Eng" ? "font-public-sans font-medium" : "font-nepali font-thin"}`}>
                {language === "Eng" ? "Mahasul Report" : "महसुल रिपोर्ट"}
              </td>
              <td className="w-[25%]">
              </td>
            </tr>
            <tr>
              <td align='center' colSpan={2} className={`w-[25%] text-black font-light text-[11px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                {language === "Eng" ? "Date: " : "मिति: "}
                {date_report?.date_from} {language === "Eng" ? "from " : "बाट "} {date_report?.date_to} {language === "Eng" ? "Upto " : "सम्म"}
              </td>
              <td align='right' className="w-[25%] text-[11px]">
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className='bg-white dark:bg-slate800 shodow rounded-md py-2'>
        <div className="relative w-full overflow-x-auto">
          <table className="w-full text-sm whitespace-nowrap text-left rtl:text-right text-slate700 dark:text-slate400">
            <thead className="text-[11px] top-0 sticky z-10 text-slate800 capitalize border-b dark:bg-slate700 bg-slate200 dark:text-slate100 dark:border-slate700">
              <tr className={`${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                <th rowSpan={2} scope="col" className={`px-2 py-0.5 border-y border-r border-slate300 dark:border-gray-700 w-10 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                 {language === "Eng" ? "S.N." : "क्र.स."} 
                </th>
                <th rowSpan={2} scope="col" className={`px-2 bg-slate200 py-0.5 border-y border-r border-slate300 dark:border-gray-700 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Member Name" : "सदस्यको नाम"} 
                </th>
                <th rowSpan={2} scope="col" className={`px-2 bg-slate200 py-0.5 border-y border-r ${language === "Eng" ? "font-public-sans" : "font-nepali"} border-slate300 dark:border-gray-700`}>
                  {language === "Eng" ? "Address" : "ठेगाना"} 
                </th>
               
                <th rowSpan={2} scope="col" className={`px-2 py-0.5 border-y border-r border-slate300 dark:border-gray-700 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                   {language === "Eng" ? "Marga/Tole" : "मार्ग/टोल"} 
                </th>
                <th align='center' rowSpan={2} scope="col" className={`px-2 py-0.5 border-y border-r border-slate300 dark:border-gray-700 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Reading Year/Month" : "महसुल वर्ष/महिना"} 
                </th>
                <th align='center' colSpan={3} scope="col" className={`px-2 py-0.5 border-y border-r border-slate300 dark:border-gray-700 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Meter Reading" : "मिटर रिडिङ"} 
                </th>
                <th align='center' rowSpan={2} scope="col" className={`px-2 py-0.5 border-y border-slate300 dark:border-gray-700 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Consume Amount" : "उपभोग रकम"} 
                </th>
              </tr>
              <tr className={`${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                <th align='center' rowSpan={2} scope="col" className={`px-2 py-0.5 border-y border-r border-slate300 dark:border-gray-700 w-10 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                 {language === "Eng" ? "Prev Unit" : "अघिल्लो एकाइ"} 
                </th>
                <th align='center' rowSpan={2} scope="col" className={`px-2 bg-slate200 py-0.5 border-y border-r border-slate300 dark:border-gray-700 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Current Unit" : "हालको एकाइ"} 
                </th>
                <th align='center' rowSpan={2} scope="col" className={`px-2 bg-slate200 py-0.5 border-y border-r ${language === "Eng" ? "font-public-sans" : "font-nepali"} border-slate300 dark:border-gray-700`}>
                  {language === "Eng" ? "Consume Unit" : "उपभोग एकाइ"} 
                </th>
              </tr>
            </thead>
            <tbody>
              {
                Array.isArray(onMahasulReport?.results) && onMahasulReport?.results?.length > 0 ? (onMahasulReport?.results?.map((item: any, index: number) => (
                  <tr key={index} className={`bg-white hover:bg-slate100 ${language === "Eng" ? "font-public-sans" : "font-nepali"} hover:cursor-pointer text-[11px]  dark:bg-slate800 text-slate800 dark:hover:bg-slate600`}>
                    <td align='center' className={`px-2 py-0.5 border-b border-r border-slate-300 dark:border-slate700 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                      {index + 1}.
                    </td>
                    <td className={`px-2 py-0.5 capitalize bg-white border-b border-r border-slate-300 dark:border-slate700 italic`}>
                      {language === "Eng" ? item?.mem_name : item?.mem_name_nep} 
                    </td>
                    <td className={`px-2 py-0.5 border-b border-r border-slate-300 dark:border-slate700 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                     {language === "Eng" ? item?.add_eng : item?.add_nep} 
                    </td>
                    <td className={`px-2 py-0.5 border-b border-r border-slate-300 dark:border-slate700 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                      {language === "Eng" ? item?.tole_name : item?.tole_name_nep} 
                    </td>
                    <td className={`px-2 py-0.5 border-b border-r border-slate-300 dark:border-slate700 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                      {item?.yearr}/{item?.monthh}
                    </td>
                    <td align='center' className={`px-2 py-0.5 border-b border-r border-slate-300 dark:border-slate700 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                       {parseFloat(item?.unit_total || 0) - parseFloat(item?.consume_unit || 0)}
                    </td>
                    <td align='center' className={`px-2 py-0.5 border-b border-r border-slate-300 dark:border-slate700 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                     {item?.unit_total}
                    </td>
                    <td align='center' className={`px-2 py-0.5 border-b border-r border-slate-300 dark:border-slate700 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                     {item?.consume_unit}
                    </td>
                     <td align='center' className={`px-2 py-0.5 border-b border-slate-300 dark:border-slate700 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                      {item?.consume_amt}
                    </td>
                  </tr>
                ))) : <tr className="bg-white text-[12px] font-public-sans dark:bg-slate800 text-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                  <td align='center' colSpan={16} className="px-2 py-1 border dark:border-gray-700">
                    <span>No Payroll Found</span>
                  </td>
                </tr>
              }

            </tbody>
          </table>
        </div>
      </div>
    </Fragment>
  )
}

export default PrintMahasulRptListView